import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DescriptionDetailedModule } from '../../description-detailed/description-detailed.module';
import { SliderModule } from '../../slider/slider.module';

import { RoomTypeModalContentComponent } from './room-type-modal-content.component';

@NgModule({
    imports: [
        CommonModule,
        SliderModule,
        DescriptionDetailedModule
    ],
    exports: [
        RoomTypeModalContentComponent
    ],
    declarations: [
        RoomTypeModalContentComponent
    ],
    providers: [],
})
export class RoomTypeModalContentModule { }
